import React from "react"
import "./StatsModule.scss"

const StatsModule = ({ data }) => {
  const statsList = data?.Stats_List?.filter(item => item.Publish !== false) || []

  if (statsList.length === 0) return null

  return (
    <section className="stats-module">
      <div className="stats-module__inner">
        {data?.Stats_Title && (
          <p className="stats-module__title">{data.Stats_Title}</p>
        )}
        {data?.Stats_Desc && (
          <h2 className="stats-module__desc">{data.Stats_Desc}</h2>
        )}

        <div className="stats-module__grid">
          {statsList.map((stat, index) => (
            <div className="stats-module__item" key={stat.id || index}>
              {/* <div className="stats-module__number">{stat.Title}</div> */}
              <div className="stats-module__number">
                {stat.Title.includes(" Hours") ? (
                    <>
                    {stat.Title.replace(" Hours", "")}{" "}
                    <span className="stats-module__number-secondary">Hours</span>
                    </>
                ) : (
                    stat.Title
                )}
                </div>
              {stat.Description && (
                <p className="stats-module__label">{stat.Description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default StatsModule